import React from "react";
import { JAPIPublicationLoader } from "../latestResearch/publications/JAPIPublicationLoader";
import { withRouter } from "react-router-dom";
import { AutoCompleteSearchBox } from "../search/searchBar/AutoCompleteSearchBox";
import PillsBar from "../search/searchBar/PillsBar";
import { useSelector } from "react-redux";
import { ViewLayout } from "pages/latestResearch/publications/ViewLayout";
import ErrorBoundary from "lib/ErrorBoundary";

export const SearchResults = withRouter(() => {
  const { filter } = useSelector((state) => state.filter);

  return (
    <ErrorBoundary className="px-2">
      <header>
        <AutoCompleteSearchBox />
        <PillsBar filter={filter} />
      </header>

      <JAPIPublicationLoader
        scrollToTop={false}
        render={(publications, _noop, data) => <ViewLayout publications={publications} data={data} />}
      />
    </ErrorBoundary>
  );
});
